module.exports = {
    SGD: [ //Singapore
        {
            name: 'M1',
            type: 1,
            logo: 'm1.png',
            amount: {
                'SGD': [3, 5, 10, 20, 30, 50, 100]
            }
        },
        {
            name: 'SingTel',
            type: 1,
            logo: 'singtel.jpg',
            amount: {
                'SGD': [3, 5, 10, 20, 30, 40, 50, 60]
            },
        },
        {
            name: 'StarHub',
            type: 1,
            logo: 'starhub.png',
            amount: {
                'SGD': [3, 5, 10, 20, 30, 40, 50, 60]
            },
        },
    ],
    IDR: [ //Indonesia
        {
            name: 'Alfamart',
            type: 221,
            logo: 'alfamart.jpg',
            amount: {
                'IDR': [50000, 100000, 200000, 500000, 1000000, 2000000]
            }
        },
        {
            name: 'Bank/ATM Transfer',
            type: 220,
            logo: 'atm_transfer.png',
            amount: {
                'IDR': [50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000]
            }
        },
        {
            name: 'Indosat',
            type: 1,
            logo: 'indosat.png',
            amount: {
                'IDR': [10000, 20000, 30000, 40000, 50000, 60000, 90000, 100000, 200000, 250000, 300000, 450000, 500000, 550000, 900000, 1000000, 1050000, 1100000]
            }
        },
        {
            name: 'Telkomsel',
            type: 1,
            logo: 'telkomsel.png',
            amount: {
                'IDR': [500, 1000, 2000, 3000, 4000, 5000, 10000, 25000, 50000, 100000, 250000, 500000]
            }
        },
        {
            name: 'Telkomsel Voucher',
            type: 320,
            logo: 'telkomsel_voucher.png',
            amount: {
                'IDR': [5000, 10000, 25000, 50000, 100000]
            }
        },
        {
            name: 'XL',
            type: 1,
            logo: 'xl.png',
            amount: {
                'IDR': [10000, 20000, 50000, 100000, 200000, 500000, 1000000]
            }
        },
        {
            name: 'H3I',
            type: 1,
            logo: 'h3i.png',
            amount: {
                'IDR': [10000, 20000, 50000, 100000, 500000, 1000000, 1300000]
            }
        },
        {
            name: 'Bolt',
            type: 1,
            logo: 'bolt.png',
            amount: {
                'IDR': [10000, 20000, 50000, 100000, 500000, 1000000, 2000000, 3000000]
            }
        },
        {
            name: 'Bitcoin',
            type: 200,
            logo: 'bitcoin.png',
            amount: {
                'IDR': [20000, 50000, 100000, 200000, 500000, 1000000, 2000000, 3000000, 4000000, 5000000]
            }
        }, {
            name: '7-Eleven',
            type: 224,
            logo: 'sevelin.jpg',
            amount: {
                'IDR': [10000, 20000, 50000, 100000, 500000, 1000000, 2000000, 5000000, 8000000, 9999500]
            }
        },
        {
            name: 'Doku Wallet',
            type: 223,
            logo: 'doku_wallet.png',
            amount: {
                'IDR': [10000, 20000, 50000, 100000, 500000, 1000000, 2000000, 5000000]
            }
        }
    ],
    MYR: [ //Malaysia
        {
            name: 'ePay',
            type: 231,
            logo: 'epay.png',
            amount: {
                'MYR': [5, 10, 20, 50, 100, 200, 500, 1000]
            }
        },
        {
            name: 'Maxis',
            type: 1,
            logo: 'maxis.png',
            amount: {
                'MYR': [1, 5, 10, 20, 50, 100]
            }
        },
        {
            name: 'DiGi',
            type: 1,
            logo: 'digi.png',
            amount: {
                'MYR': [1, 5, 10, 20, 50, 60]
            }
        },
        {
            name: 'Bitcoin',
            type: 201,
            logo: 'bitcoin.png',
            amount: {
                'MYR': [
                    2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 3000, 4000
                ]
            }
        }
    ],
    THB: [ //Thailand
        {
            name: 'True Money Cash Card',
            type: 340,
            logo: 'truemoney.png',
            amount: {
                'THB': [50, 100, 200, 500, 1000]
            }
        },
        {
            name: 'Bank&payment counters',
            type: 331,
            logo: 'otc.png',
            amount: {
                'THB': [10, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 30000, 40000, 49000]
            }
        }
    ],
    PHP: [ //Philippines
        {
            name: 'Globe',
            type: 1,
            logo: 'globe.png',
            amount: {
                'PHP': [10, 20, 50, 100, 200, 300, 400, 500, 1000, 2000]
            }
        },
        {
            name: 'Smart & Sun',
            type: 1,
            logo: 'smart_sun.jpg',
            amount: {
                'PHP': [10, 20, 50, 100, 200, 500, 1000, 2000]
            }
        },
        {
            name: 'Bank payments',
            type: 250,
            logo: 'phbanks.png',
            amount: {
                'PHP': [10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]
            }
        },
        {
            name: 'Counter payments',
            type: 251,
            logo: 'photc.png',
            amount: {
                'PHP': [50, 100, 200, 500, 1000, 2000, 5000, 10000]
            }
        },
        {
            name: 'GCash',
            type: 252,
            logo: 'gcash.png',
            amount: {
                'PHP': [1, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]
            }
        }
    ],
    VND: [ //Vietnam
        {
            name: 'Vietnam vouchers',
            type: 350,
            logo: 'vietnam.png',
            amount: {
                'VND': [10000, 20000, 50000, 100000, 200000, 300000, 500000]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/config/pay/codapay.js